module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n        This integration is active.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24d8553a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/popupParts/stateLabelArea/activated.vue
// module id = 2792
// module chunks = 0